import { useParams } from 'react-router-dom';
import { IconEmpty } from 'src/icons';

import { useInvoiceDetailsQuery } from '../billing/billingApi';
import { useSingleStudentDetailsQuery } from '../single-student/singleStudentApi';

export const EmptyServicesState = () => {
  const { id } = useParams();
  const { data: invoiceData } = useInvoiceDetailsQuery(id!);
  const { data: student } = useSingleStudentDetailsQuery(invoiceData?.studentId || '', {
    skip: !invoiceData?.studentId,
  });

  return (
    <div className="flex h-full w-full flex-col items-center">
      <div className="flex justify-center text-center">
        <div className="h-10 w-10 rounded-[200px] bg-secondary-900">
          <IconEmpty className="m-2 h-6 w-6 text-secondary-300" />
        </div>
      </div>
      <p className="mt-4 text-center text-neutral-100 typography-heading-md">
        {student?.firstName ? `${student.firstName} is` : 'Student is'} not approved for any related
        services.
      </p>
    </div>
  );
};
